import { querystring } from './../../../helpers';
import { mapGetters } from 'vuex'

const FilterResult = {
	name: 'FilterResult',
	props: {
		apiEndpoint: {
			type: String,
			required: true
		},
		numberToShow: {
			type: Number,
			required: false,
			default: 5,
		},
		className: {
			type: String,
			required: true,
		}
	},
	mounted: function() {

		const currentPage = querystring.getSingleValue(this.pageParam);
		if(!currentPage) {
			querystring.add(this.pageParam, 1, true);
			this.page = 1;
		} else {
			this.page = parseInt(currentPage[0]);
		}
		const currentSize = querystring.getSingleValue(this.sizeParam);
		if(!currentSize) {
			querystring.add(this.sizeParam, this.numberToShow, true);
		}
		this.updateFilter();
	},
	created: function() {
		this.pageParam = 'page';
		this.sizeParam = 'size';
		this.updateFilter = (refresh = true) => {
			this.$nextTick(() => {
				if(refresh) {
					querystring.add(this.pageParam, 1, true);
					this.page = 1;
				}
				superagent.post(this.apiEndpoint + location.search)
				.set('accept', 'json').
				end((err, { body, statusCode }) => {
					if(!err) {
						const { result, total } = body;
						this.result = (!result || result.length == 0) ? [] : (refresh ? result : this.result.concat(result));
						this.total = !total ? 0 : total;
						this.showing = this.result.length;
					}
				});
			});
		}
	},
	data: function() {
		return {
			result: [],
			total: 0,
			page: 1,
			showing: 0,
		};
	},
	methods: {
		showMore: function() {
			this.page += 1;
			querystring.add(this.pageParam, this.page, true);
			this.updateFilter(false);
		},
	},
	template: `
		<section :class="className">
			<slot :result="result" :page="1" :showing="showing" :total="total" :showMore="showMore"></slot>
		</section>
	`,
	watch: {
		updated: function() {
			this.updateFilter();
		},
	},
	computed: {
		...mapGetters({
			updated: 'filter/updated'
		}),
  },
};

export default FilterResult;



// WEBPACK FOOTER //
// ../shared/components/filter/filter-result/index.js